import Text from "../components/Text";
import styles from "./Legal.module.css";

export default function AccountDeletion() {
    return (
        <div class={styles.page}>
            <div class={styles.heroBand}>
                <div class={styles.heroInner}>
                    <span class={styles.eyebrow}><Text val="ADEL_EYEBROW" /></span>
                    <h1 class={styles.heroTitle}><Text val="ADEL_TITLE" /></h1>
                    <p class={styles.heroSubtitle}><Text val="ADEL_SUBTITLE" /></p>
                </div>
            </div>

            <main class={styles.content}>
                <section class={styles.section}>
                    <h2><Text val="ADEL_STEPS_TITLE" /></h2>
                    <ol>
                        <li>
                            <Text val="ADEL_STEP_1" />{" "}
                            <a href="mailto:elias.traunbauer@gmx.at?subject=Account%20deletion">elias.traunbauer@gmx.at</a>
                        </li>
                        <li><Text val="ADEL_STEP_2" /></li>
                        <li><Text val="ADEL_STEP_3" /></li>
                        <li><Text val="ADEL_STEP_4" /></li>
                    </ol>
                    <p class={styles.muted}><Text val="ADEL_STEPS_NOTE" /></p>
                </section>

                <section class={styles.section}>
                    <h2><Text val="ADEL_DELETED_TITLE" /></h2>
                    <p><Text val="ADEL_DELETED_INTRO" /></p>
                    <ul>
                        <li><Text val="ADEL_DELETED_ACCOUNT" /></li>
                        <li><Text val="ADEL_DELETED_MS" /></li>
                        <li><Text val="ADEL_DELETED_BOTS" /></li>
                        <li><Text val="ADEL_DELETED_CONFIG" /></li>
                        <li><Text val="ADEL_DELETED_LOGS" /></li>
                        <li><Text val="ADEL_DELETED_SESSIONS" /></li>
                    </ul>
                </section>

                <section class={styles.section}>
                    <h2><Text val="ADEL_KEPT_TITLE" /></h2>
                    <ul>
                        <li><strong><Text val="ADEL_KEPT_GRACE_T" /></strong>: <Text val="ADEL_KEPT_GRACE_B" /></li>
                        <li><strong><Text val="ADEL_KEPT_ACCESSLOG_T" /></strong>: <Text val="ADEL_KEPT_ACCESSLOG_B" /></li>
                    </ul>
                    <p><Text val="ADEL_KEPT_NOTHING_ELSE" /></p>
                </section>

                <section class={styles.section}>
                    <h2><Text val="ADEL_APP_TITLE" /></h2>
                    <p><Text val="ADEL_APP_BODY" /></p>
                </section>

                <section class={styles.section}>
                    <h2><Text val="ADEL_MORE_TITLE" /></h2>
                    <p>
                        <Text val="ADEL_MORE_BODY" /> <a href="/datenschutz"><Text val="ADEL_MORE_LINK" /></a>
                    </p>
                    <div class={styles.card}>
                        <p>
                            Elias Traunbauer<br />
                            Wasserwerkstraße 2<br />
                            4052 Ansfelden<br />
                            Oberösterreich, Österreich<br />
                            <Text val="ADEL_EMAIL_LABEL" />: <a href="mailto:elias.traunbauer@gmx.at">elias.traunbauer@gmx.at</a>
                        </p>
                    </div>
                </section>
            </main>
        </div>
    );
}
